<template>
  <div id="search-job-container" class="search-job-container">
    <div class="search-place-container" ref="searchPlaceContainer">
      <!-- accor customized, but accor will be redirect in old django html-->
      <!-- <form v-if="customized_page" id="search-form" action=""> -->
      <div v-if="customized_page" id="search-form" v-show="showSearchForm">
        <div class="search-keywords-container">
          <input
            ref="searchKeywords"
            class="search-keywords-common search-keywords"
            type="search" v-model="search.keywords">
        </div>
      </div>
      <!-- </form> -->
      <template v-else>
        <div
          class="clear-search customized"
          :class="!has_custom_mobile_landing_page ? 'hide' : ''"
          @click="onClearSearchClick">
          {{ $t('common.clearSearch') }}
        </div>
        <form style="padding: 0px;" id="search-form-customized" @submit.prevent="_fetchJobList" action="javascript:return true">
          <div
            class="search-container"
            :class="languageCode === 'en' ? 'en' : ''"
            @click="onSearchContainerClick">
            <input
              ref="searchKeywordsPlace"
              class="search-keywords-place"
              type="search"
              v-model="placeKeywords"/>
            <span class="search-icon">
              <span class="icon"></span>
            </span>
          </div>
        </form>
      </template>
    </div>
    <template v-if="!isCustomJobFilter">
      <div class="sort-msg-container" ref="sortMsgContainer">
        <div :class="className.sortMsgTag.length > 0 ? className.sortMsgTag.join(' ') : 'reward-tag'">
          <label>{{ sortMsgTag }}</label>
          <span></span>
        </div>
        <div ref="innerIconContainer" class="inner-switch-icon-container map-switch-icon-container order-switch-icon-container">
          <span
            :class="className.innerSwitchIcon.length > 0 ? className.innerSwitchIcon.join(' ') : 'switch-icon'"
            @click="onInnerSwitchIconClick"></span>
        </div>
      </div>

      <div class="switch-icon-container map-switch-icon-container" ref="switchIconContainer">
        <span class="switch-icon"></span>
      </div>

      <div class="search-types">
        <span
          v-for="(item, index) in companyJobFilter"
          :key="index"
          :id="item.id"
          :class="active[item.name] && 'active-filter'"
          @click="item.onIconClick">
          <div v-if="item.nameStyle" class="custom-filter-name" :style="item.nameStyle">{{ item.text }}</div>
          <template v-else>{{ item.text }}</template>
          <span :class="item.iconClass"></span>
        </span>
      </div>

      <div
        v-show="container.location"
        class="location-container need-hide-location"
        ref="locationContainer">
        <div class="scroll-content-wrapper" ref="scrollContent">
          <div class="cbd-filter-container">
            <!-- <div class="cbd-tabs">
              <a
                class="city-tab"
                :class="className.city.join(' ')"
                @click="onCbdTabClick('city')">
                <span class="text">{{ tab.city.isSelected ? tab.city.label : $t('jobFilter.location.city') }}</span>
                <span class="icon"></span>
              </a>
              <a
                class="region-tab"
                :class="className.region.join(' ')"
                @click="onCbdTabClick('region')">
                <span class="text">{{ tab.region.isSelected ? tab.region.label : $t('jobFilter.location.region') }}</span>
                <span class="icon"></span>
              </a>
              <a
                v-if="!hide_trading_area"
                class="area-tab"
                :class="className.area.join(' ')"
                @click="onCbdTabClick('area')">
                <span class="text">{{ tab.area.isSelected ? tab.area.label : $t('jobFilter.location.area') }}</span>
                <span class="icon"></span>
              </a>
            </div> -->

            <div class="city-container" ref="cityContainer" v-show="container.city">
              <!-- add from js template id=filter-city-template -->
              <div class="loading loc-loading" v-show="loading.city"></div>
              <template v-if="!loading.city">
                <div class="current-city">
                  <label>{{ $t('jobFilter.location.currentCity') }} : </label>
                  <div class="location-message">
                    <p class="with-location" v-show="showWithLocation">
                      <span>{{ $t('jobFilter.location.yourLocation') }} : </span>
                      <span id="position-city" class="city-name" @click="onCityNameClick(currentPositionCity.id, currentPositionCity.name)">{{ currentPositionCity.name }}</span>
                    </p>

                    <p class="no-location" v-show="!showWithLocation">
                      {{ $t('jobFilter.location.noLocation') }}
                    </p>
                  </div>
                </div>
                <div class="hot-city-list">
                  <label>{{ $t('jobFilter.location.hotCities') }} : </label>
                  <div class="hot-cities">
                    <span
                      class="city-name"
                      :class="tempActive.cityIds.length === 0 ? 'active-name' : ''"
                      @click="onCityNameClick(0, $t('jobFilter.location.allCities'))">{{ $t('jobFilter.location.allCities') }}</span>
                    <span
                      class="city-name"
                      v-for="(item, index) in hotCityList"
                      :key="index"
                      :class="tempActive.cityIds.includes(item.id) ? 'active-name' : ''"
                      @click="onCityNameClick(item.id, item.i18nName)">
                      {{ item.i18nName }}
                    </span>
                  </div>
                </div>
                <div class="group-city-list">
                  <label>{{ $t('jobFilter.location.allCities') }} : </label>
                  <div class="letter-index">
                    <a
                      v-for="(letter, index) in letterIndex"
                      :key="index"
                      @click="onLetterIndexClick(letter)">
                      {{ letter }}
                    </a>
                  </div>
                  <div class="cities-container">
                    <div
                      :id="`city-${letter}`"
                      class="one-group"
                      v-for="(letter, index) in letterIndex"
                      :key="index">
                      <label>{{ letter }}</label>
                      <div class="group-cities">
                        <span
                          class="city-name"
                          v-for="(item, index) in groupCityList[letter]"
                          :key="index"
                          :class="tempActive.cityIds.includes(item.id) ? 'active-name' : ''"
                          @click="onCityNameClick(item.id, item.i18nName)">
                          {{ item.i18nName }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="region-container" v-show="container.region">
              <!-- add from js template id=filter-region-template -->
              <div class="loading loc-loading" v-show="loading.region"></div>
              <div class="region-list" v-show="!loading.region">
                <span
                  class="region-name"
                  :class="active.regionId === 0 ? 'active-name' : ''"
                  @click="onReionNameClick(0, $t('jobFilter.location.allRegions'))">{{ $t('jobFilter.location.allRegions') }}</span>
                <span
                  class="region-name"
                  v-for="(item, index) in regionResults"
                  :key="index"
                  :class="active.regionId === item.id ? 'active-name' : ''"
                  @click="onReionNameClick(item.id, languageCode === 'en' ? item.name : item.cn_name)">
                  {{ languageCode === 'en' ? item.name : item.cn_name }}
                </span>
              </div>
            </div>
            <div v-if="!hide_trading_area" class="area-container" v-show="container.area">
              <!-- add from js template id=filter-area-template -->
              <div class="loading loc-loading" v-show="loading.area"></div>
              <div class="area-list" v-show="!loading.area">
                <span
                  class="area-name"
                  :class="active.areaId === 0 ? 'active-name' : ''"
                  @click="onAreaNameClick(0, $t('jobFilter.location.allAreas'))">{{ $t('jobFilter.location.allAreas') }}</span>
                <span
                  class="area-name"
                  v-for="(item, index) in areaResults"
                  :key="index"
                  :class="active.areaId === item.id ? 'active-name' : ''"
                  @click="onAreaNameClick(item.id, languageCode === 'en' ? item.name : item.cn_name)">
                  {{ languageCode === 'en' ? item.name : item.cn_name }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="filter-btn-container">
          <span
            class="filter-btn"
            @click="onFilterBtnClick(true)">{{ $t('common.btn.ok') }}</span>
        </div>
      </div>

      <div
        v-show="container.jobType"
        class="job-type-container need-hide-industry"
        ref="jobTypeContainer">
        <div class="type">
          <div class="arrow-top"></div>
          <span class="first">{{ $t('jobFilter.jobType.industry') }}</span>
          <span>{{ $t('jobFilter.jobType.type') }}</span>
        </div>
        <ul class="job-parent-Industry-container" v-show="container.parentIndustry">
          <!-- add from js template id=filter-job-industry-template -->
          <li
            :class="active.parentIndustryId === 0 && 'active-parent-industry'"
            @click="onParentIndustryClick(0, null)">{{ $t('jobFilter.jobType.allIndustries') }}</li>
          <li
            v-for="(item, index) in jobIndustryResults"
            :key="index"
            :class="active.parentIndustryId === item.id && 'active-parent-industry'"
            @click="onParentIndustryClick(item.id, (languageCode === 'en' ? item.name : item.cn_name))">
            {{ languageCode === 'en' ? item.name : item.cn_name }}
          </li>
        </ul>

        <ul class="job-son-Industry-container">
          <!-- add from js template id=filter-job-type-template -->
          <li
            :class="active.sonIndustryId === 0 ? 'active-son-industry' : ''"
            @click="onSonIndustryClick(0)">{{ $t('jobFilter.jobType.allTypes') }}</li>
          <li
            v-for="(item, index) in jobTypeResults"
            :key="index"
            :class="active.sonIndustryId === item.id ? 'active-son-industry' : ''"
            @click="onSonIndustryClick(item.id)">
            {{ languageCode === 'en' ? item.name : item.cn_name }}
          </li>
        </ul>
      </div>

      <div
        v-show="container.salary"
        class="salary-container need-hide-salary"
        ref="salaryContainer">
        <ul class="salary-info-container">
          <!-- add from js template id=filter-common-template -->
          <li
            :class="tempActive.salaryIds.length === 0 && 'active-salary'"
            @click="onSalaryClick(0, ($t('jobFilter.label.salary')))">{{ $t('common.all') }}</li>
          <li
            v-for="(item, index) in salaryResults"
            :key="index"
            :class="tempActive.salaryIds.includes(item.id) && 'active-salary'"
            @click="onSalaryClick(item.id, item.i18nName)">
            {{ item.i18nName }}
          </li>
        </ul>
      </div>

      <div
        v-show="container.workTime"
        class="work-time-container need-hide-work-time"
        ref="workTimeContainer">
        <ul class="work-time-info-container">
          <!-- add from js template id=filter-common-template -->
          <li
            :class="tempActive.workTimeIds.length === 0 && 'active-work-time'"
            @click="onWorkTimeClick(0, ($t('jobFilter.label.workTime')))">{{ $t('common.all') }}</li>
          <li
            v-for="(item, index) in workTimeResults"
            :key="index"
            :class="tempActive.workTimeIds.includes(item.id) && 'active-work-time'"
            @click="onWorkTimeClick(item.id, item.i18nName)">
            {{ item.i18nName }}
          </li>
        </ul>
      </div>

      <div
        v-show="container.roleType"
        class="role-type-container need-hide-role-type"
        ref="roleTypeContainer">
        <ul class="role-type-info-container">
          <li
            :class="tempActive.roleTypeIds.length === 0 && 'active-role-type'"
            @click="onRoleTypeClick(0, ($t('jobFilter.label.roleType')))">{{ $t('common.all') }}</li>
          <li
            v-for="roleType in roleTypeList"
            :key="roleType.key"
            :class="tempActive.roleTypeIds.includes(roleType.key) && 'active-role-type'"
            @click="onRoleTypeClick(roleType.key, roleType.value)"
          >
          {{ roleType.value }}
          </li>
        </ul>
      </div>

      <template v-if="companyJobFilterItems && Object.keys(companyJobFilterItems).length > 0">
        <div
          v-for="(itemList, filterId) in companyJobFilterItems"
          v-show="container[`customFilter${filterId}`]"
          class="custom-filter-container need-hide-custom-filter"
          :ref="`customFilterContainer${filterId}`"
          :key="filterId">
          <ul class="custom-filter-info-container">
            <li
              :class="tempActive[`customFilter${filterId}ItemId`]?.length === 0 && 'active-custom-filter-item'"
              @click="onCustomFilterClick(0, filterId, (defaultCustomJobFilterLabel[`customFilter${filterId}ItemId`]))">{{ $t('common.all') }}</li>
            <li
              v-for="(item, index) in itemList"
              :key="index"
              :class="tempActive[`customFilter${filterId}ItemId`]?.includes(item.id) && 'active-custom-filter-item'"
              @click="onCustomFilterClick(item.id, filterId, item.i18nName)">
              {{ item.i18nName }}
            </li>
          </ul>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import Optional from 'optional-js'
import { CUSTOM_JOB_FILTER_IDS, OVERSEAS_COMPANY_ID } from '@/constant/common'
import { addI18nProperty } from '@/i18n'

const TYPE_SEARCH = '5'
const TYPE_FILTER_INDUSTRY = '1'
const TYPE_FILTER_SALARY = '2'
const TYPE_FILTER_WORK_TIME = '3'
const TYPE_FILTER_LOACTION = '4'
const TYPE_FILTER_ROLE_TYPE = '6'
const TYPE_FILTER_CUSTOM_FILTER = '7'
const TYPE_ALL = '0' // both searh and filter
export default {
  props: {
    search: {
      type: Object,
      required: true
    },
    customized_page: {
      type: Boolean,
      required: true
    },
    has_custom_mobile_landing_page: {
      type: Boolean,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    url_name: {
      type: String // no used in vue, can instead of $route
    },
    isSearching: {
      type: Boolean,
      required: true
    },
    hide_trading_area: {
      type: Boolean,
      required: true
    },
    searchOverlay: {
      type: Object,
      required: true
    },
    company_job_filter: {
      type: Array
    },
    company_job_filter_items: {
      type: Object
    },
    hasCustomFilter: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      hotCityList: [],
      letterIndex: [],
      groupCityList: [],
      regionResults: [],
      areaResults: [],
      jobIndustryResults: [],
      jobTypeResults: [],
      salaryResults: [],
      workTimeResults: [],
      hasFilterChanged: false,
      cacheObj: {
        parentIndustryCache: null,
        subIndustryCache: {},
        jobTypesCache: null,
        salaryCache: null,
        workTimeCache: null,
        locationCache: {
          city: null,
          hotCity: null
        }
      },

      currentPositionCity: {
        id: null,
        name: null
      },
      showWithLocation: false,
      active: {
        location: false,
        jobType: false,
        salary: false,
        workTime: false,
        roleType: false,
        parentIndustryId: null,
        sonIndustryId: null,
        roleTypeIds: [],
        salaryIds: [],
        workTimeIds: [],
        cityIds: [],
        regionId: null,
        areaId: null
      },
      tempActive: {
        location: false,
        jobType: false,
        salary: false,
        workTime: false,
        roleType: false,
        parentIndustryId: null,
        sonIndustryId: null,
        roleTypeIds: [],
        salaryIds: [],
        workTimeIds: [],
        cityIds: [],
        regionId: null,
        areaId: null
      },
      tab: {
        city: {
          isSelected: false,
          label: null
        },
        region: {
          isSelected: false,
          label: null
        },
        area: {
          isSelected: false,
          label: null
        }
      },
      className: {
        city: [],
        region: [],
        area: [],
        innerSwitchIcon: [],
        sortMsgTag: []
      },
      container: {
        location: false,
        city: false,
        region: false,
        area: false,
        jobType: false,
        salary: false,
        workTime: false,
        roleType: false
      },
      loading: {
        city: false,
        region: false,
        area: false
      },
      showSearchForm: false,
      sortMsgTag: '',
      defaultCustomJobFilterLabel: {},
      jobIndustryName: null,
      disableFilterBtn: true,
      placeKeywords: null,
      isInitCityId: true,
      isCallAutoRenderCBD: false
    }
  },
  computed: {
    hide_mobile_job_filter () {
      const HIDE_MOBILE_JOB_FILTER = [87, 6085] // from backend constant
      const HIDE_JOB_FILTER_FOR_SINGLE_COMPANY = [6238, 6240, 6703, 6266, 6268, 6265, 6267, 6260, 6309, 6310, 6311, 6119] // from backend constant
      const company = this.company
      if (company) {
        const rootCompany = company.root_company
        if ((rootCompany && HIDE_MOBILE_JOB_FILTER.indexOf(rootCompany.id) > -1) ||
             HIDE_JOB_FILTER_FOR_SINGLE_COMPANY.indexOf(company.id) > -1) {
          return true
        } else if (company.isOverseasCompany) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isCustomJobFilter () {
      return CUSTOM_JOB_FILTER_IDS.indexOf(this.company.id) > -1
    },
    isOverseasCompany () {
      return OVERSEAS_COMPANY_ID.indexOf(this.company.id) > -1
    },
    languageCode () {
      return this.$i18n.locale
    },
    companyJobFilter () {
      let iconClass = null
      const vm = this
      if (this.has_custom_mobile_landing_page) {
        iconClass = 'icomoon-arrow-down'
      } else {
        iconClass = 'icon'
      }
      const locationFilter = {
        id: 'work-location',
        name: 'location',
        get text () {
          return vm.getLocationName()
        },
        onIconClick: this.onLocationIconClick,
        iconClass: iconClass
      }
      const jobTypeFilter = {
        id: 'job-type',
        name: 'jobType',
        text: this.$t('jobFilter.label.jobType'),
        onIconClick: this.onJobTypeIconClick,
        iconClass: iconClass
      }
      const salaryFilter = {
        id: 'salary-info',
        name: 'salary',
        get text () {
          return vm.getSalaryName()
        },
        onIconClick: this.onSalaryIconClick,
        iconClass: iconClass
      }
      const workTimeFilter = {
        id: 'work-time',
        name: 'workTime',
        get text () {
          return vm.getWorkTimeName()
        },
        onIconClick: this.onWorkTimeIconClick,
        iconClass: iconClass
      }
      const roleTypeFilter = {
        id: 'role-type',
        name: 'roleType',
        get text () {
          return vm.getRoleTypeName()
        },
        onIconClick: this.onRoleTypeIconClick,
        iconClass: iconClass
      }

      const filters = {}
      if (this.has_custom_mobile_landing_page || !this.isOverseasCompany) {
        if (this.hasCustomFilter) {
          for (const item of this.company_job_filter) {
            if (item.is_default) {
              switch (item.name) {
                case 'Location':
                  if (this.company && this.company.id && this.url_name !== 'job-list') {
                    filters.locationFilter = locationFilter
                  } else {
                    filters.jobTypeFilter = jobTypeFilter
                  }
                  break
                case 'Salary':
                  filters.salaryFilter = salaryFilter
                  break
                case 'Role Type':
                  filters.roleTypeFilter = roleTypeFilter
                  break
                case 'Work Time':
                  filters.workTimeFilter = workTimeFilter
                  break
              }
            } else {
              let text = this.languageCode === 'en' ? item.name : item.cn_name
              if (this.languageCode !== 'en') {
                if (text.length > 4) {
                  text = text.substring(0, 4) + '...'
                }
              }
              const filterName = `customFilter${item.id}ItemId`
              // eslint-disable-next-line vue/no-side-effects-in-computed-properties
              vm.defaultCustomJobFilterLabel[filterName] = text
              let nameStyle = null
              if (this.languageCode === 'en') {
                nameStyle = 'width: 60px; line-height: 14px; vertical-align: middle;'
              } else {
                nameStyle = 'line-height: 14px; vertical-align: middle;'
              }
              const customJobFilter = {
                id: `custom-job-filter-${item.id}`,
                name: `customFilter${item.id}`,
                nameStyle: nameStyle,
                get text () {
                  return vm.getCustomFilterName(item.id)
                },
                onIconClick: (event) => this.onCustomFilterIconClick(event, item),
                iconClass: iconClass
              }
              filters[filterName] = customJobFilter
            }
          }
        } else if (!this.isOverseasCompany) {
          if (this.company && this.company.id && this.url_name !== 'job-list') {
            filters.locationFilter = locationFilter
            filters.salaryFilter = salaryFilter
            filters.workTimeFilter = workTimeFilter
            filters.roleTypeFilter = roleTypeFilter
          } else {
            filters.jobTypeFilter = jobTypeFilter
            filters.salaryFilter = salaryFilter
            filters.workTimeFilter = workTimeFilter
            filters.roleTypeFilter = roleTypeFilter
          }
        }
      }
      return filters
    },
    roleTypeList () {
      return [
        { key: 'F', value: this.$t('jobFilter.roleType.fullTime') },
        { key: 'P', value: this.$t('jobFilter.roleType.partTime') },
        { key: 'I', value: this.$t('jobFilter.roleType.intern') }
      ]
    },
    companyJobFilterItems () {
      return _.mapValues(this.company_job_filter_items, value => {
        return _.map(value, item => {
          addI18nProperty(item, 'i18nName', 'cn_name', 'name')
          item.id = `${item.id}`
          return item
        })
      })
    }
  },
  created () {
    const currentCity = JSON.parse(sessionStorage.getItem('current_city'))
    if (currentCity) {
      this.currentPositionCity.id = currentCity.id
      this.currentPositionCity.name = currentCity.cn_name
    }
    // this.initClassName()

    this.placeKeywords = this.search.keywords
    this.searchOverlay.onClose = () => {
      this.onFilterBtnClick()
      this.switchActive()
      this.switchContainer()
      this._showHideMask(false, TYPE_ALL)
      this.placeKeywords = this.search.keywords
    }
    this.$eventBus.$on('setFilterCity', (filterCurrentCity) => {
      if (filterCurrentCity) {
        const cityName = this.languageCode === 'en' ? filterCurrentCity.name : filterCurrentCity.cn_name
        const cityId = filterCurrentCity.id
        this.currentPositionCity.id = cityId
        this.currentPositionCity.name = cityName

        this.active.cityIds = [cityId]
        // this._getJobRegions(cityId)
        // this.container.city = false
        // this.container.region = true
        // _.remove(this.className.city, item => item === 'selected-tab')
        // this.className.city.push('delete-tab')
        // this.tab.city.isSelected = true
        // this.tab.city.label = cityName
        // this.className.region.push('selected-tab')
        // this._setHistoryCBD(cityId, null, null)
      }
    })
  },
  mounted () {
    this.init()

    const url = window.location.href
    if (url.indexOf('#') > -1) {
      const hashParams = url.split('#')[1].split('&')
      if (hashParams.indexOf('trigger_city=1') > -1) {
        // if (utils.getHashValueByParam('trigger_city') == 1) {
        // $('#work-location').trigger('click')
        this.onLocationIconClick()
        // }
      }
    }
  },
  methods: {
    ...mapActions('job', [
      'getCurrentCityByIp',
      'getWorkLocationCitys',
      'getSonIndustry',
      'getSonIndustryById',
      'getParentIndustry',
      'getJobSalaryList',
      'getJobWorkTimeList',
      'getJobRegions',
      'getJobAreas'
    ]),
    ...mapGetters('account', ['getCurrentAccount']),

    // init
    init () {
      const isAppleCompany = this.company.id === 87
      // this.initClassName()
      this._registerSearchEvent() // empty function
      // this._initFilterAction() === onXXXClick()

      this._initJobDetailPageStatus() // at here call the _showCompanyPage is wrong

      if (!isAppleCompany) {
        // _initSearchBtnEvent() move to jobList page
        // _initBackEvent() move to ListSearch page
        // _clearSearchEvent() change to functions, one is in this page and another is moved to ListSearch page
        this._registerEvent()// empty function
        this._autoRenderCBD()
      } else {
        // _initBackEvent() move to ListSearch page
        // _initJobDetailCollapse() // customed for apple, move to CustomedCompanyJobList
        // }
      }
      // _initLoadMoreEvent() no element with class .more-jobs-load
      // if (!this._isCandidateViewRefJobs(refj)) {
      // _registerSwitchToMapEvent() === onMapSwichIconClick()
      // }
      this.active.parentIndustryId = parseInt(this.search.jobIndustryId) || 0
      this.active.sonIndustryId = parseInt(this.search.jobTypeId) || 0
      this.active.roleTypeIds = this.search.roleType ? this.search.roleType.split(',') : [] // not number
      this.active.salaryIds = this.search.jobSalaryId ? this.search.jobSalaryId.split(',') : []
      this.active.workTimeIds = this.search.jobWorkTimeId ? this.search.jobWorkTimeId.split(',') : []
      this.active.cityIds = this.search.areaCityId ? this.search.areaCityId.split(',') : []
      this.active.regionId = parseInt(this.search.areaRegionId) || null
      this.active.areaId = parseInt(this.search.areaId) || null
      _.forEach(this.search.customFilters, item => {
        this.$set(this.active, `customFilter${item.id}ItemId`, item.value ? item.value.split(',') : [])
      })
      if (this.active.cityIds.length > 0) {
        this._getWorkLocationCitys()
      }
      if (this.active.salaryIds.length > 0) {
        this._getSalaryInfo()
      }
      if (this.active.workTimeIds.length > 0) {
        this._getWorkTimeInfo()
      }
      this.tempActive = _.cloneDeep(this.active)
    },
    initClassName () {
      this.className.city.push('selected-tab')
      if (this.hide_trading_area) {
        this.className.city.push(' two-tabs')
        this.className.region.push('two-tabs')
      }
      this.tab.city.isSelected = false
      this.tab.city.label = this.$t('jobFilter.location.city')
    },
    _initJobDetailPageStatus () {
      const isCompanyAccor = false
      if (window.location.href.indexOf('#') === -1 && !isCompanyAccor) {
        this._showCompanyPage(1)
      } else {
        this._showCompanyPage(2)
      }
    },
    /**
     * common functions
     */
    // empty function
    _registerEvent () {
      // _initSearchPlaceholder() TODO search-placeholder is in HoneywellFilter
      // _registerSearchFocusEvent() all click event has registed
      // _renderRoleType() already finish with vue data
      // _registerFilterIndustryEvent() === onJobTypeIconClick()
      // _registerFilterSalaryEvent() === onSalaryIconClick()
      // _registerFilterWorkTimeEvent() === onWorkTimeIconClick()
      // _registerFilterRoleTypeEvent() === onRoleTypeIconClick()
      // _registerFilterWorkLocationEvent() === onLocationIconClick()
      // CBD Render
      // _initCBDFilterScroll() === onLetterIndexClick()
      // _initChooseCity() === onCityNameClick()
      // _initChooseRegion() === onReionNameClick()
      // _initChooseArea() === onAreaNameClick()
      // _clearFilterCBD() === onCbdTabClick()
      // _initFilterCBD() === onFilterBtnClick()
      // _setMaxHeight() max height will set onLocationIconClick()
    },

    // empty function
    _registerSearchEvent () {
      // $('#search-form').on('submit', function () {
      //   this._commonFilterListAction()
      //   this._showHideMask(false, TYPE_SEARCH)
      //   return false
      // })
      // register in ListSearch vue page with @keypress.enter...

      // $('#search-form').on('click', '.search-keywords-cancel', function (e) {
      //   // e.stopPropagation()
      //   // $inputKeywords.val('')
      //   // $('.search-keywords').trigger('submit')
      //   // reset keywords and search again
      // })
      // register in ListSearch vue page

      // $('#search-mask').on('click', function (e) {
      //   // this._showHideMask(false, TYPE_ALL)
      // })
      // already set in created()

      // $('#search-form-customized').on('submit', function () {
      //   this._commonFilterListAction('customized')
      //   return false
      // })
      // register in this vue page with @keypress.enter...
    },
    getLocationName () {
      let locationName = ''
      // if (this.tab.city.isSelected) {
      //   locationName += this.tab.city.label
      // }
      // if (this.tab.region.isSelected) {
      //   locationName += this.tab.region.label
      // }
      if (this.active.cityIds?.length) {
        locationName = _.chain(this.groupCityList).map(value => _.filter(value, city => this.active.cityIds.includes(city.id)))
          .flatMap().map(city => city.i18nName).join(',').value()
      }
      return this.getRefineFilterName(this.$t('jobFilter.label.location'), locationName)
    },
    getSalaryName () {
      let labelName = ''
      if (this.active.salaryIds?.length) {
        labelName = _.chain(this.salaryResults)
          .filter(item => this.active.salaryIds.includes(item.id))
          .map(item => item.i18nName)
          .join(',')
          .value()
      }
      return this.getRefineFilterName(this.$t('jobFilter.label.salary'), labelName)
    },
    getWorkTimeName () {
      let labelName = ''
      if (this.active.workTimeIds?.length) {
        labelName = _.chain(this.workTimeResults)
          .filter(item => this.active.workTimeIds.includes(item.id))
          .map(item => item.i18nName)
          .join(',')
          .value()
      }
      return this.getRefineFilterName(this.$t('jobFilter.label.workTime'), labelName)
    },
    getRoleTypeName () {
      let labelName = ''
      if (this.active.roleTypeIds?.length) {
        labelName = _.chain(this.roleTypeList)
          .filter(item => this.active.roleTypeIds.includes(item.key))
          .map(item => item.value)
          .join(',')
          .value()
      }
      return this.getRefineFilterName(this.$t('jobFilter.label.roleType'), labelName)
    },
    getCustomFilterName (customFilterId) {
      const filterName = `customFilter${customFilterId}ItemId`
      let labelName = ''
      if (this.active[filterName]?.length) {
        labelName = _.chain(this.companyJobFilterItems)
          .map((value, key) => {
            const filterName = `customFilter${key}ItemId`
            if (this.active[filterName]?.length) {
              return _.filter(value, item => this.active[filterName].includes(item.id))
            }
            return []
          })
          .flatMap()
          .map(item => item.i18nName)
          .join(',')
          .value()
      }
      return this.getRefineFilterName(this.defaultCustomJobFilterLabel[filterName], labelName)
    },
    getRefineFilterName (filterLabel, filterName) {
      const filterLength = filterLabel.length
      let resultFilterNname = filterLabel
      if (filterName && filterName.length > 0) {
        resultFilterNname = filterName
        if (filterName.length > filterLength) {
          resultFilterNname = filterName.substring(0, filterLength - 1) + '...'
        }
      }
      return resultFilterNname
    },
    _autoRenderCBD () {
      if (_.isEmpty(this._getHistoryCBD())) {
        this.isInitCityId = true
        this.isCallAutoRenderCBD = true
        this._getWorkLocationCitys()
      }
    },

    switchActive (name) {
      if (name) {
        if (!this.active.hasOwnProperty(name)) {
          this.$set(this.active, name, true)
        } else {
          if (this.active[name]) {
            this.active[name] = false
          } else {
            this.active[name] = true
          }
        }
      }
      for (const key in this.active) {
        if (key !== name) {
          if (typeof this.active[key] === 'boolean' || key.indexOf('Id') < 0) {
            this.active[key] = false
          }
        }
      }
    },

    switchContainer (name) {
      if (name) {
        if (this.container.hasOwnProperty(name)) {
          this.container[name] = !this.container[name]
        } else {
          this.$set(this.container, name, true)
        }
      } else {
        for (const key in this.container) {
          this.container[key] = false
        }
      }
    },

    setMainElementHeight ($event, container) {
      this.$nextTick(() => {
        const containerHeight = container.clientHeight
        const windowHeight = window.innerHeight
        const clickHeight = $event.clientY
        if ((windowHeight - clickHeight - containerHeight) <= 10) {
          const mainEl = this.$root.$el
          const mainElHegith = clickHeight + containerHeight + 0.1 * windowHeight
          mainEl.style.height = mainElHegith + 'px'
          mainEl.scrollTo({ top: clickHeight / 2 })
        }
      })
    },

    _setSearchPostionCustomed () {
      const location = this.$refs.locationContainer
      const body = document.body
      const height = body.clientHeight - 100
      location.style.height = height + 'px'
      location.style.position = 'fixed'
      location.style.top = '100px'
    },

    _showHideMask (isShow, type, customFilterId) {
      const isAppleCompany = this.company.id === 87
      const isCompanyInfo = false // TODO need computed, but it is always false now with jobList page
      if (isCompanyInfo && isAppleCompany) {
        return false
      }
      if (isShow) {
        this.tempActive = _.cloneDeep(this.active)
        // $('#search-mask').show()
        this.searchOverlay.show = true
        // $('.need-hide').hide()
        this.switchContainer()
        // $('#search-mask').css('z-index', 1000)
        this.searchOverlay.zIndex = 1000
        if (type === TYPE_SEARCH) {
          // $('.search-types > span').removeClass('active-filter')
          this.switchActive()
          // $('#search-mask').css('z-index', 10000)
          this.searchOverlay.zIndex = 10000
          // $inputKeywords.val($('.search-keywords-place').val())
          this.$emit('setkeywords', this.placeKeywords)
          this.showSearchForm = true
          this.$emit('showSearchForm', true)
          // $inputKeywords.focus()
          // this.$refs.searchKeywords.focus()
          this.$nextTick(() => {
            document.querySelector('.search-keywords').focus()
          })
        } else if (type === TYPE_FILTER_INDUSTRY) {
          this.container.jobType = true
        } else if (type === TYPE_FILTER_SALARY) {
          this.container.salary = true
        } else if (type === TYPE_FILTER_WORK_TIME) {
          this.container.workTime = true
        } else if (type === TYPE_FILTER_LOACTION) {
          this.container.location = true

          this.container.city = true
          // this.container.region = false
          // this.container.area = false
          // if (this.active.cityId && this.active.cityId !== 0) {
          //   this.container.region = true
          // } else if (this.active.regionId && this.active.regionId !== 0) {
          //   this.container.area = true
          // } else {
          //   this.container.city = true
          // }
        } else if (type === TYPE_FILTER_ROLE_TYPE) {
          this.container.roleType = true
        } else if (type === TYPE_FILTER_CUSTOM_FILTER) {
          if (this.container.hasOwnProperty(`customFilter${customFilterId}`)) {
            this.container[`customFilter${customFilterId}`] = true
          } else {
            this.$set(this.container, `customFilter${customFilterId}`, true)
          }
        }
        const mainEl = this.$root.$el
        mainEl.style.overflow = 'hidden'
      } else {
        // $('.search-types > span').removeClass('active-filter')
        // this.active.hideAll
        this.switchContainer()
        this.switchActive()
        // $('#search-mask').hide()
        this.searchOverlay.show = false
        if (type === TYPE_SEARCH) {
          // $('.search-keywords-place').val($inputKeywords.val())
          // if (this.search.keywords) {
          //   $('.search-placeholder').hide()

          // } else {
          //   $('.search-placeholder').show()
          // }
          // TODO search-placeholder is in HoneywellFilter
        }
        // only in company-detail-new page, we remove the mask. So the search form should always show.
        // if (!this.isCompanyAccor) { // not company accor
        // TODO check isCompanyAccor is always false ???
        if (isCompanyInfo && isAppleCompany) {
          // $('#search-form').show()
          this.showSearchForm = true
          this.$emit('showSearchForm', true)
        } else {
          // $('#search-form').hide()
          this.showSearchForm = false
          this.$emit('showSearchForm', false)
        }
        if (this.hasFilterChanged) {
          this.setSearchParams()
          this.$emit('fetchJobList', false)
          this.hasFilterChanged = false
        }
        const mainEl = this.$root.$el
        mainEl.style.height = ''
        mainEl.style.overflow = ''
      }
    },

    _getHistoryCBD () {
      const CBDInfo = JSON.parse(sessionStorage.getItem('cbd'))
      if (CBDInfo) {
        return {
          city: CBDInfo.city,
          region: CBDInfo.region,
          area: CBDInfo.area
        }
      }
      return null
    },

    _setHistoryCBD (cityId, regionId, areaId) {
      const CBDInfo = {
        city: cityId,
        region: regionId,
        area: areaId
      }
      sessionStorage.setItem('cbd', JSON.stringify(CBDInfo))
    },

    _customizedLanguage () {
      const currentCompany = this.company
      const rootCompanyId = currentCompany.root_company && currentCompany.root_company.id
      const customized = {
        language_code: '',
        only_root_company: ''
      }
      if (currentCompany) {
        if ([2435].indexOf(currentCompany.id) !== -1) { // accor
          customized.language_code = 'zh-cn'
        }
      }
      if (rootCompanyId && ([2435].indexOf(rootCompanyId) !== -1)) { // customized accor son company
        customized.only_root_company = 1
      }
      return customized
    },

    _setFilterBtnStatus () {
      if (this.className.city.indexOf('delete-tab') > -1 ||
        this.className.region.indexOf('delete-tab') > -1 ||
        this.className.area.indexOf('delete-tab') > -1) {
        this.disableFilterBtn = false
      } else {
        this.disableFilterBtn = true
      }
    },

    setSearchParams () {
      if (this.isSearching) {
        return
      }
      const parentIndustryId = this.active.parentIndustryId
      const sonIndustryId = this.active.sonIndustryId
      const salaryIds = this.active.salaryIds
      const workTimeIds = this.active.workTimeIds
      const roleTypeIds = this.active.roleTypeIds
      let cityIds = this.active.cityIds
      const regionId = this.active.regionId
      const areaId = this.active.areaId
      const refj = this.search.refj
      let orderBy = null
      if (this._isCandidateViewRefJobs(refj)) {
        if (this.className.innerSwitchIcon.indexOf('updated-time-icon') > -1) {
          orderBy = 'time_desc'
        } else {
          orderBy = 'earning_desc'
        }
      }
      if (this.isInitCityId) {
        cityIds = []
      }

      this.search.jobIndustryId = parentIndustryId || 0
      this.search.jobTypeId = sonIndustryId || 0
      this.search.jobSalaryId = salaryIds.join(',') || null
      this.search.jobWorkTimeId = workTimeIds.join(',') || null
      this.search.roleType = roleTypeIds.join(',') || null
      this.search.areaCityId = cityIds.join(',') || null
      this.search.areaRegionId = regionId
      this.search.areaId = areaId
      this.search.orderBy = orderBy
      const customFilters = []
      _.forEach(this.active, (value, key) => {
        if (key.startsWith('customFilter') && key.includes('ItemId')) {
          let filterId = key.replace('customFilter', '').replace('ItemId', '')
          filterId = parseInt(filterId)
          customFilters.push({
            id: filterId,
            value: value.join(',')
          })
        }
      })
      this.search.customFilters = customFilters
    },

    _commonFilterListAction (customized) {
      // this.setHashParams(customized)
      // need setSearchParams
      this.setSearchParams()
      // this._showCompanyPage(2) always is 2 with jobList page, move it to ListSearch and jobList page created()
      this.$emit('fetchJobList', false, customized)

      this._showHideMask(false, TYPE_ALL)
    },

    _showCompanyPage (page) {
      // _showCompanyPage at init method === need call after company api response
      // page=1 --> company job page,
      // page=2 --> company job search page
      if (!this.has_custom_mobile_landing_page) {
        if (page === 1) {
          // $('.more-jobs-wrapper').removeClass('hide')
          this.$emit('showWrapper', { 'more-jobs-wrapper': true, 'company-job-list-wrapper': false })
        } else if (page === 2) {
          // $('.company-job-list-wrapper').removeClass('hide')
          // $('.more-jobs-wrapper').addClass('hide')
          this.$emit('showWrapper', { 'more-jobs-wrapper': false, 'company-job-list-wrapper': true })
        }
      } else {
        this.$emit('showWrapper', { 'company-job-list-wrapper': true })
      }
    },

    _isCandidateViewRefJobs (refj) {
      // return refj && !($('#employee-account-flag').val() === '1')
      return refj && !(this.getCurrentAccount.employee)
    },

    show_order_tip (type) {
      const sortMsgContainer = this.$refs.sortMsgContainer
      if (type === 'reward') {
        this.className.sortMsgTag[0] = 'reward-tag'
        this.sortMsgTag = this.$t('jobFilter.tip.rewardSort')
      } else {
        this.className.sortMsgTag[0] = 'updated-time-tag'
        this.sortMsgTag = this.$t('jobFilter.tip.timeSort')
      }
      sortMsgContainer.style.visibility = 'visible'

      setTimeout(() => {
        this.$refs.sortMsgContainer.style.visibility = 'hidden'
      }, 2000)
    },

    // no using with jobList
    _showIcon (refj) {
      if (this._isCandidateViewRefJobs(refj)) {
        // $('#main .common-wrapper .search-place-container').attr('class', 'order-search-place-container')
        this.$refs.searchPlaceContainer.calssName += ' order-search-place-container'
        // $('#main .inner-switch-icon-container').css('display', 'inline-block')
        this.$refs.innerIconContainer.style.display = 'inline-block'
        // $('.sort-msg-container').css('display', 'inline-block')
        this.$refs.sortMsgContainer.style.display = 'inline-block'
        // let orderBy = utils.getHashValueByParam('order_by')
        const orderBy = this.search.orderBy
        if (orderBy === 'time_desc') {
          this.className.innerSwitchIcon[0] = 'updated-time-icon'
        } else {
          this.className.innerSwitchIcon[0] = 'reward-icon'
        }
      } else {
        this.$refs.switchIconContainer.style.display = 'inline-block'
        this.$refs.switchIconContainer.firstElementChild.style.display = 'inline-block'
      }
    },

    _fetchJobList () {
      if (this.has_custom_mobile_landing_page) {
        this.search.keywords = this.placeKeywords
        this.setSearchParams()
        this.$refs.searchKeywordsPlace.blur()
        this.$emit('fetchJobList', false, 'customized')
      }
    },
    /**
     * will send request with api
     */
    async _getParentIndustry () {
      const cacheObj = this.cacheObj
      if (cacheObj.parentIndustryCache) {
        this.container.parentIndustry = true
      } else {
        const resp = Optional.ofNullable(await this.getParentIndustry()).map(item => item).orElse({})
        if (resp) {
          this.cacheObj.parentIndustryCache = resp
          // let templateStr = _.template($('#filter-job-industry-template').html(), { results: cacheObj.parentIndustryCache })
          // $parentIndustyContainer.html(templateStr)
          this.jobIndustryResults = this.cacheObj.parentIndustryCache
          // let filterParams = this.search
          // let selectedId = filterParams.selectedIndustry ? filterParams.selectedIndustry : 0
          // this.active.parentIndustryId = selectedId
          // $parentIndustyContainer.find('li[data-id=' + parseInt(selectedId) + ']').addClass('active-parent-industry')
          this._getSonIndustry(this.active.parentIndustryId)
        } else {
          // alert(resp.code);
        }
      }
    },
    async _getSalaryInfo () {
      if (this.cacheObj.salaryCache) {
        this.container.salary = true
      } else {
        const resp = Optional.ofNullable(await this.getJobSalaryList()).map(item => item).orElse({})
        if (resp) {
          this.cacheObj.salaryCache = _.map(resp, item => {
            addI18nProperty(item, 'i18nName', 'cn_name', 'name')
            item.id = `${item.id}`
            return item
          })
          // let templateStr = _.template($('#filter-common-template').html(), { results: cacheObj.salaryCache })
          // $salaryContainer.html(templateStr)
          this.salaryResults = this.cacheObj.salaryCache
        } else {
          // alert(resp.code);
        }
      }
    },
    async _getWorkTimeInfo () {
      if (this.cacheObj.workTimeCache) {
        // $workTimeContainer.show()
        this.container.workTime = true
      } else {
        const resp = Optional.ofNullable(await this.getJobWorkTimeList()).map(item => item).orElse({})
        if (resp) {
          this.cacheObj.workTimeCache = _.map(resp, item => {
            addI18nProperty(item, 'i18nName', 'cn_name', 'name')
            item.id = `${item.id}`
            return item
          })
          // let templateStr = _.template($('#filter-common-template').html(), { results: cacheObj.workTimeCache })
          // $workTimeContainer.html(templateStr)
          this.workTimeResults = this.cacheObj.workTimeCache
        } else {
          // alert(resp.code);
        }
      }
    },
    async _getCurrentCityByIp () {
      let currentCity = JSON.parse(sessionStorage.getItem('current_city'))
      let cityName
      if (currentCity) {
        if (!_.isEmpty(currentCity)) {
          cityName = this.languageCode === 'en' ? currentCity.name : currentCity.cn_name
          // $('#position-city').text(cityName).attr('data-id', currentCity.id).data('cn_name', currentCity.cn_name)
          this.currentPositionCity.id = currentCity.id
          this.currentPositionCity.name = cityName
          this.showWithLocation = true
          // if (_.isEmpty(this._getHistoryCBD()) && currentCity.id) {
          //   this.onCityNameClick(currentCity.id, cityName, true)
          // }
        } else {
          this.showWithLocation = false
        }
      } else {
        const resp = Optional.ofNullable(await this.getCurrentCityByIp()).map(item => item).orElse({})
        if (resp && !_.isEmpty(resp.current_city)) {
          currentCity = resp.current_city
          sessionStorage.setItem('current_city', JSON.stringify(currentCity))
          const cityName = this.languageCode === 'en' ? currentCity.name : currentCity.cn_name
          this.currentPositionCity.id = currentCity.id
          this.currentPositionCity.name = cityName
          this.showWithLocation = true
          // if (_.isEmpty(this._getHistoryCBD()) && currentCity.id) {
          // $($('.city-name[data-id=' + currentCity.id + ']')[0]).trigger('click')
          //   this.onCityNameClick(currentCity.id, cityName, true)
          // }
        } else {
          this.showWithLocation = false
        }
      }
    },
    async _getWorkLocationCitys () {
      /** ***special logic for customized company *******/
      const customizedInfo = this._customizedLanguage()
      const languageCode = customizedInfo.language_code
      /** ***special logic for customized company *******/
      this.loading.location = true
      try {
        const resp = Optional.ofNullable(await this.getWorkLocationCitys(languageCode)).map(item => item).orElse({})
        if (resp.total > 0) {
          const cacheObj = this.cacheObj
          _.forEach(resp.hotCityList, city => {
            city.id = `${city.id}`
            addI18nProperty(city, 'i18nName', 'cn_text', 'text')
          })
          _.forEach(resp.groupCityList, cityList => {
            _.forEach(cityList, city => {
              city.id = `${city.id}`
              addI18nProperty(city, 'i18nName', 'cn_text', 'text')
            })
          })
          cacheObj.locationCache.hotCity = resp.hotCityList
          cacheObj.locationCache.city = resp.groupCityList
          let letterIndex = []
          _.each(cacheObj.locationCache.city, (item, key) => {
            letterIndex.push(key)
          })
          letterIndex = _.sortBy(letterIndex, letter => letter)
          this.letterIndex = letterIndex
          this.hotCityList = cacheObj.locationCache.hotCity
          this.groupCityList = cacheObj.locationCache.city

          await this._getCurrentCityByIp()
          // const historyCBD = this._getHistoryCBD()
          // if (historyCBD && (historyCBD.city || historyCBD.city === 0)) {
          // when there is hot cities $('.city-name[data-id=' + _getHistoryCBD().city + ']').length == 2
          // $($('.city-name[data-id=' + historyCBD.city + ']')[0]).trigger('click')
          //   this.onCityNameClick(historyCBD.city, null, true)
          // }
        } else {
          // alert(resp.code);
        }
        if (!this.search.cityName) {
          if (this.active.cityIds.length === 0) {
            this.search.cityName = null
          } else if (this.active.cityIds.length === 1) {
            this.search.cityName = this.getLocationName()
          } else {
            this.search.cityName = this.$t('companyJobList.multiLocations')
          }
          // _.forEach(this.groupCityList, value => {
          //   const filterCity = _.find(value, { id: this.active.cityId })
          //   if (filterCity) {
          //     this.search.cityName = filterCity.i18nName
          //     return false
          //   }
          // })
        }
      } finally {
        this.loading.location = false
      }
    },
    async _getJobRegions (cityId) {
      if (!cityId || cityId === 0) {
        return
      }
      this.loading.region = true
      try {
        const resp = Optional.ofNullable(await this.getJobRegions(cityId)).map(item => item).orElse({})
        if (resp && resp.code === 0) {
          // templateStr = _.template($('#filter-region-template').html(), { results: resp.data })
          // $regionContainer.html(templateStr)
          this.regionResults = resp.data
          const historyCBD = this._getHistoryCBD()
          if (historyCBD && (historyCBD.region || historyCBD.region === 0)) {
            // $('.region-name[data-id=' + historyCBD.region + ']').trigger('click')
            this.onReionNameClick(historyCBD.region, null, true)
          }
        } else {
          // alert(resp.code);
        }
      } finally {
        this.loading.region = false
      }
    },
    async _getJobAreas (regionId) {
      if (this.hide_trading_area || !regionId || regionId === 0) {
        return
      }
      this.loading.region = true
      try {
        const resp = Optional.ofNullable(await this.getJobAreas(regionId)).map(item => item).orElse({})
        if (resp && resp.code === 0) {
          // templateStr = _.template($('#filter-area-template').html(), { results: resp.data })
          // $areaContainer.html(templateStr)
          this.areaResults = resp.data
          const historyCBD = this._getHistoryCBD()
          if (historyCBD && (historyCBD.area || historyCBD.area === 0)) {
            this.onAreaNameClick(historyCBD.area, null, true)
          }
        } else {
          // alert(resp.code);
        }
      } finally {
        this.loading.region = false
      }
    },
    async _getSonIndustry (jobIndustryId) {
      const subIndustryCache = this.cacheObj.subIndustryCache
      if (subIndustryCache[jobIndustryId]) {
        this.jobTypeResults = subIndustryCache[jobIndustryId]
        return
      }

      jobIndustryId = jobIndustryId ? 0 : jobIndustryId
      if (jobIndustryId === 0) {
        const resp = Optional(await this.getSonIndustry()).map(item => item).orElse({})
        if (resp) {
          // let templateStr = _.template($('#filter-job-type-template').html(), { results: resp.data })
          // $sonIndustyContainer.html(templateStr)
          subIndustryCache[jobIndustryId] = resp
        } else {
          // alert(resp.code);
        }
      } else {
        const resp = await this.getSonIndustryById(jobIndustryId)
        subIndustryCache[jobIndustryId] = resp
      }
      this.jobTypeResults = subIndustryCache[jobIndustryId]
    },
    /**
     * event: onXXXClick
     */
    onLocationIconClick () {
      const cacheObj = this.cacheObj
      const locationContainer = this.$refs.locationContainer
      if (this.has_custom_mobile_landing_page) {
        // document.body.scrollTop = document.documentElement.scrollTop = 300
        this._setSearchPostionCustomed()
      } else {
        // set_maxHeight
        const otherElementHeight = document.querySelector('.company-job-list-wrapper').clientHeight
        const maxHeight = document.body.clientHeight - otherElementHeight
        locationContainer.style.height = maxHeight + 'px'
      }
      // $('.search-types > span:not("#' + this.id + '")').removeClass('active-filter')
      // $(this).toggleClass('active-filter')
      this.switchActive('location')
      if (this.active.location) {
        if (cacheObj.locationCache.city && cacheObj.locationCache.hotCity) {
          this.container.location = true
          this._getCurrentCityByIp()
        } else {
          this._getWorkLocationCitys()
        }
        this._showHideMask(true, TYPE_FILTER_LOACTION)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    async onJobTypeIconClick ($event) {
      this.switchActive('jobType')
      if (this.active.jobType) {
        if (this.cacheObj.parentIndustryCache) {
          this.container.jobType = true
        } else {
          await this._getParentIndustry()
        }
        this._showHideMask(true, TYPE_FILTER_INDUSTRY)
        this.setMainElementHeight($event, this.$refs.jobTypeContainer)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    async onSalaryIconClick ($event) {
      this.switchActive('salary')
      if (this.active.salary) {
        if (this.cacheObj.salaryCache) {
          this.container.salary = true
        } else {
          await this._getSalaryInfo()
        }
        this._showHideMask(true, TYPE_FILTER_SALARY)
        this.setMainElementHeight($event, this.$refs.salaryContainer)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    async onWorkTimeIconClick ($event) {
      this.switchActive('workTime')
      if (this.active.workTime) {
        if (this.cacheObj.workTimeCache) {
          this.container.workTime = true
        } else {
          await this._getWorkTimeInfo()
        }
        this._showHideMask(true, TYPE_FILTER_WORK_TIME)
        this.setMainElementHeight($event, this.$refs.workTimeContainer)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    onRoleTypeIconClick ($event) {
      this.switchActive('roleType')
      if (this.active.roleType) {
        this.container.roleType = true
        this._showHideMask(true, TYPE_FILTER_ROLE_TYPE)
        this.setMainElementHeight($event, this.$refs.roleTypeContainer)
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    async onCustomFilterIconClick ($event, customFilter) {
      const filterName = `customFilter${customFilter.id}`
      this.switchActive(filterName)
      if (this.active[filterName]) {
        this.$set(this.container, filterName, true)
        this._showHideMask(true, TYPE_FILTER_CUSTOM_FILTER, customFilter.id)
        this.setMainElementHeight($event, this.$refs[`customFilterContainer${customFilter.id}`][0])
      } else {
        this._showHideMask(false, TYPE_ALL)
      }
    },

    onSearchContainerClick () {
      if (!this.has_custom_mobile_landing_page) {
        this._showHideMask(true, TYPE_SEARCH)
      }
    },

    onMapSwichIconClick () {
      const refj = this.search.refj
      if (this._isCandidateViewRefJobs(refj)) {
        return
      }
      window.location.href = '/job-list/?vm=map' + window.location.hash
    },

    onLetterIndexClick (letter, $event) {
      // let $container = $('.scroll-content-wrapper')
      // let target = $(this).data('href')
      // $container.scrollTo(target)

      const height = document.getElementById(`city-${letter}`).offsetTop
      this.$refs.scrollContent.scrollTo({ top: height })
    },

    onCityNameClick (cityId, cityName, isAutoClick) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      if (!isAutoClick) {
        this.isInitCityId = false
      }
      // if (!cityName) {
      //   if (cityId === 0) {
      //     cityName = this.$t('jobFilter.location.allCities')
      //   } else {
      //     const hotCity = this.hotCityList.find(item => item.id === cityId)
      //     if (hotCity) {
      //       cityName = hotCity.i18nName
      //     } else {
      //       let city = null
      //       for (const key in this.groupCityList) {
      //         city = this.groupCityList[key].find(item => item.id === cityId)
      //         if (city && city.id) {
      //           break
      //         }
      //       }
      //       if (city) {
      //         cityName = city.i18nName
      //       }
      //     }
      //   }
      // }
      this.onFilterChange(this.tempActive.cityIds, cityId)
      // this._getJobRegions(cityId)
      // $cityContainer.hide()
      // $regionContainer.show()
      // this.container.city = false
      // this.container.region = true
      if (this.tempActive.cityIds.length === 0) {
        // if (isAutoClick) {
        //   this.container.city = true
        // } else {
        //   this.onFilterBtnClick(false)
        // }
        // this.tab.city.isSelected = false
        this.search.cityName = null
      } else if (this.tempActive.cityIds.length === 1) {
        // change tab text
        // _.remove(this.className.city, item => item === 'selected-tab')
        // this.className.city.push('delete-tab')
        // this.tab.city.isSelected = true
        // this.tab.city.label = cityName
        // this.className.region.push('selected-tab')
        // this._setFilterBtnStatus()
        this.search.cityName = this.getLocationName()
      } else {
        this.search.cityName = this.$t('companyJobList.multiLocations')
      }
      // if (isAutoClick) {
      //   this.container.region = false
      // }
    },

    onReionNameClick (regionId, regionName, isAutoClick) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      if (!isAutoClick) {
        this.isInitCityId = false
      }
      if (!regionName) {
        if (regionId === 0) {
          regionName = this.$t('jobFilter.location.allRegions')
        } else {
          const region = this.regionResults.find(item => item.id === regionId)
          regionName = this.languageCode === 'en' ? region.name : region.cn_name
        }
      }
      this.active.regionId = regionId
      this.container.city = false
      if (!this.hide_trading_area) {
        this._getJobAreas(regionId)
        this.container.region = false
        this.container.area = true
      }

      if (regionId === 0) {
        if (isAutoClick) {
          this.container.region = true
        } else {
          // this.onCbdTabClick('region')
          this.onFilterBtnClick(false)
          // TODO check may have problem
        }
        this.tab.region.isSelected = false
      } else {
        // change tab text
        _.remove(this.className.region, item => item === 'selected-tab')
        this.className.region.push('delete-tab')
        this.className.area.push('selected-tab')
        this.tab.region.isSelected = true
        this.tab.region.label = regionName
        this._setFilterBtnStatus()
      }
    },

    onAreaNameClick (areaId, areaName, isAutoClick) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      if (!areaName) {
        if (areaId === 0) {
          areaName = this.$t('jobFilter.location.allAreas')
        } else {
          const area = this.areaResults.find(item => item.id === areaId)
          if (area) {
            areaName = this.languageCode === 'en' ? area.name : area.cn_name
          }
        }
      }
      const preAreaId = this.active.areaId
      this.active.areaId = areaId
      if (areaId === 0) {
        if (preAreaId && preAreaId !== areaId) {
          // this.onCbdTabClick('area')
          this.onAreaNameClick(areaId, areaName, true)
          return false
        }
        if (!isAutoClick) {
          this.onFilterBtnClick(false)
        }
      } else {
        // change tab text
        _.remove(this.className.area, item => item === 'selected-tab')
        this.className.area.push('delete-tab')
        this.tab.area.isSelected = true
        this.tab.area.label = areaName
        this._setFilterBtnStatus()
      }
    },

    onCbdTabClick (type) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      if ((this.className[type].indexOf('delete-tab') < 0)) {
        return
      }
      if (type === 'region' && (this.active.cityId && this.active.cityId === 0)) {
        return
      }
      if (type === 'area' && (this.active.regionId && this.active.regionId === 0)) {
        return
      }

      _.remove(this.className.city, item => item === 'selected-tab')
      _.remove(this.className.region, item => item === 'selected-tab')
      _.remove(this.className.area, item => item === 'selected-tab')
      this.container.city = false
      this.container.region = false
      this.container.area = false

      let CBDInfo = this._getHistoryCBD() || {}
      if (type === 'city') {
        _.remove(this.className.city, item => item === 'delete-tab')
        _.remove(this.className.region, item => item === 'delete-tab')
        _.remove(this.className.area, item => item === 'delete-tab')
        this.tab.city.isSelected = false
        this.tab.city.label = this.$t('jobFilter.location.city')
        this.tab.region.isSelected = false
        this.tab.region.label = this.$t('jobFilter.location.region')
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.active.cityId = null
        this.active.regionId = null
        this.active.areaId = null

        this.className.city.push('selected-tab')
        this.container.city = true
        CBDInfo = {}
      } else if (type === 'region') {
        _.remove(this.className.region, item => item === 'delete-tab')
        _.remove(this.className.area, item => item === 'delete-tab')
        this.tab.region.isSelected = false
        this.tab.region.label = this.$t('jobFilter.location.region')
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.active.regionId = null
        this.active.areaId = null
        this.className.region.push('selected-tab')
        this.container.region = true
        CBDInfo.region = null
        CBDInfo.area = null
      } else if (type === 'area') {
        _.remove(this.className.area, item => item === 'delete-tab')
        this.active.areaId = null
        this.tab.area.isSelected = false
        this.tab.area.label = this.$t('jobFilter.location.area')
        this.className.area.push('selected-tab')
        this.container.area = true
        CBDInfo.area = null
      }
      sessionStorage.setItem('cbd', JSON.stringify(CBDInfo))
      this._setFilterBtnStatus()
    },

    onFilterBtnClick (isUserClick) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      if (isUserClick === true) {
        this.isInitCityId = false
      }
      this.active = this.tempActive
      this._showHideMask(false)
      // const cityId = this.active.cityId
      // const regionId = this.active.regionId
      // const areaId = this.active.areaId
      // if (cityId.length === 0 && !regionId && !areaId) {
      //   return
      // }

      // this._setHistoryCBD(cityId, regionId, areaId)
      // this._commonFilterListAction()
    },

    onParentIndustryClick (jobIndustryId, jobIndustryName) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      this.active.parentIndustryId = jobIndustryId
      this.jobIndustryName = jobIndustryName
      this._getSonIndustry(jobIndustryId)
    },

    onSonIndustryClick (jobTypeId, jobTypeName) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      this.active.sonIndustryId = jobTypeId
      let resultJobTypeName = ''
      if (this.jobIndustryName) {
        resultJobTypeName = this.jobIndustryName
      }
      if (jobTypeName) {
        resultJobTypeName += jobTypeName
      }
      this.companyJobFilter.jobTypeFilter.text = this.getRefineFilterName(this.$t('jobFilter.label.jobType'), resultJobTypeName)
      this._commonFilterListAction()
    },

    onRoleTypeClick (roleTypeId, roleTypeName) {
      this.onFilterChange(this.tempActive.roleTypeIds, roleTypeId)
    },
    onSalaryClick (salaryId, salaryName) {
      this.onFilterChange(this.tempActive.salaryIds, salaryId)
    },

    onFilterChange (item, value) {
      if (this.isSearching) {
        this._showHideMask(false)
        return
      }
      this.hasFilterChanged = true
      if (value === 0) {
        item = item.splice(0)
      } else if (item.includes(value)) {
        item = item.splice(item.indexOf(value), 1)
      } else {
        item.push(value)
      }
    },

    onWorkTimeClick (workTimeId, workTimeName) {
      this.onFilterChange(this.tempActive.workTimeIds, workTimeId)
    },

    onCustomFilterClick (customFilterItemId, customFilterId, customFilterName) {
      const filterName = `customFilter${customFilterId}ItemId`
      const active = this.tempActive[filterName]
      if (!active) {
        this.$set(this.tempActive, filterName, [])
      }
      this.onFilterChange(this.tempActive[filterName], customFilterItemId)
    },

    onInnerSwitchIconClick () {
      if (this.className.innerSwitchIcon.indexOf('updated-time-icon') > -1) {
        this.className.innerSwitchIcon[0] = 'reward-icon'
        this.show_order_tip('reward')
      } else {
        this.className.innerSwitchIcon[0] = 'updated-time-icon'
        this.show_order_tip('reward')
      }
      this._commonFilterListAction()
    },

    onClearSearchClick () {
      this._showHideMask(false)
      if (this.isSearching) {
        return
      }
      // _clearFilters()
      this.placeKeywords = null
      this.active.parentIndustryId = 0
      this.active.sonIndustryId = 0
      this.active.roleTypeIds = []
      this.active.salaryIds = []
      this.active.workTimeIds = []
      this.active.cityIds = []
      this.active.regionId = null
      this.active.areaId = null
      // if (this.companyJobFilter.roleTypeFilter) {
      //   this.companyJobFilter.roleTypeFilter.text = this.$t('jobFilter.label.roleType')
      // }
      // if (this.companyJobFilter.salaryFilter) {
      //   this.companyJobFilter.salaryFilter.text = this.$t('jobFilter.label.salary')
      // }
      // if (this.companyJobFilter.workTimeFilter) {
      //   this.companyJobFilter.workTimeFilter.text = this.$t('jobFilter.label.workTime')
      // }
      if (this.companyJobFilter.jobTypeFilter) {
        this.companyJobFilter.jobTypeFilter.text = this.$t('jobFilter.label.jobType')
      }
      _.forEach(this.active, (value, key) => {
        if (key.startsWith('customFilter') && key.includes('ItemId')) {
          this.$set(this.active, key, [])
          // if (this.companyJobFilter[key]) {
          //   this.companyJobFilter[key].text = this.defaultCustomJobFilterLabel[key]
          // }
        }
      })
      this.tempActive = _.cloneDeep(this.active)
      // this.onCbdTabClick('city')
      // sessionStorage.removeItem('cbd')
      this.$emit('clearSearch')
    }
  },
  watch: {
    company (value) {
      this._initJobDetailPageStatus()
    }
  }
}
</script>

<style lang="scss" scoped>
.cbd-filter-container {
  .group-city-list .letter-index a {
    margin-bottom: -2px;
  }

  .hot-city-list {
    word-break: break-all;
    word-wrap: break-word;
    .hot-cities {
      .city-name {
        display: inline-block;

        &.active-name {
          color: var(--text-color, #0096cc);
        }
      }
    }
  }

  .group-city-list {
    .group-cities {
      .city-name {
        &.active-name {
          color: var(--text-color, #0096cc);
        }
      }
    }
  }

  .hot-city-list .hot-cities, .group-city-list .group-cities, .region-list, .area-list {
    span {
      margin-bottom: -2px;
    }
  }
}

.search-job-container {
  .search-types {
    padding: 0 3% 10px;
    color: #fff;
    display: flex;

    span {
      padding: 0 1%;
      border-right: 1px solid #aaa;
      font-size: 12px;
      display: inline-block;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      line-height: 16px;
      flex: 1;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        border-right: none;
        padding-right: 0;
      }

      &.half {
        width: 48%;
      }
    }

    .custom-filter-name {
      display: inline-block;
      overflow: hidden;
      position: relative;
      height: 15px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .filter-btn-container {
    position: fixed;
    bottom: 0;
    z-index: 10000;
    width: 100%;
    padding: 10px 0;

    .filter-btn {
      background: var(--custom-color, #f76502);
      color: #fff;
      height: 36px;
      line-height: 36px;
      width: 50%;
      display: block;
      text-align: center;
      border-radius: 20px;
      margin: 0 auto;
      font-size: 16px;
    }
  }
}

.salary-container {
  .active-salary {
    color: var(--text-color, #0096cc);
    border-bottom-color: var(--text-color, #0096cc);
  }
}

.work-time-container {
  .active-work-time {
    color: var(--text-color, #0096cc);
    border-bottom-color: var(--text-color, #0096cc);
  }
}

.role-type-container {
  .active-role-type {
    color: var(--text-color, #0096cc);
    border-bottom-color: var(--text-color, #0096cc);
  }
}

.custom-filter-container {
  .active-custom-filter-item {
    color: var(--text-color, #0096cc);
    border-bottom-color: var(--text-color, #0096cc);
  }
}
</style>
